import { useEffect, useState } from "react";

import websocketService from "services/websocket";

import styles from "./Chart.module.css";

const TICK_MS = 1000;

// Серверное время, а не Date.now(): часы в углу графика должны показывать
// реальное текущее время, а не то, что показывают (возможно, рассинхронизированные)
// часы пользователя — иначе метка теряет смысл как ориентир.
const formatNow = () => {
  const date = new Date(websocketService.getCurrentServerTime());
  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const ChartClock = () => {
  const [now, setNow] = useState(formatNow);

  useEffect(() => {
    const id = setInterval(() => setNow(formatNow()), TICK_MS);
    return () => clearInterval(id);
  }, []);

  return <div className={styles.clock}>{now}</div>;
};

export default ChartClock;
